import React from 'react';
import { Box } from 'components/ui';
import LoadingActivityCard from 'components/Content/BeautyInsider/BeautyInsiderModules/LoadingActivityCard/LoadingActivityCard';

const styles = {
    root: `
        margin-top: 16px;
        &>div:last-child {
            border: none;
            margin-bottom: -16px;
        }
    `
};

const LoadingActivityCardWrapper = ({ numberOfCards }) => {
    return <Box css={styles.root}>
        {
            Array.from({ length: numberOfCards }).map((_, index) => (
                <LoadingActivityCard key={index} />
            ))
        }
    </Box>;
};

export default LoadingActivityCardWrapper;
